import {Box} from '@mui/material';
import AurInfographic from '../../../common/aur-infographic/AurInfographic';
import aurInfographicTestData from '../../../common/aur-infographic/aurInfographicData';

const Infographic = () => {
  return (
    <Box overflow="hidden" padding="16px">
      <AurInfographic cellConfigs={aurInfographicTestData} />
    </Box>
  );
};
export default Infographic;
